export enum PriceType {
  HighConfidence = 0,
  NoRecentValue = 1,
  NewValue = 2,
  LowConfidence = 3,
  WeightedAverage = 4,
  Manual = 5,
  FixedBecauseMissing = 6,
  LeagueBecauseMissing = 7,
  BasedOnReward = 8,
  Capped = 9,
}

export enum Economy {
  League = "League",
  LeagueHardcore = "LeagueHardcore",
  Standard = "Standard",
  StandardHardcore = "StandardHardcore",
  Fixed = "Fixed",
}

export interface PriceHistoryEntry {
  price: number;
  ts: string;
  type?: PriceType;
}

export interface ManualPricedItem {
  name: string;
  value: number;
}

export interface PricedItem {
  name: string;
  price: number;
  ts: string;
  type?: PriceType;
  history?: PriceHistoryEntry[];
}

export interface PricedClusterJewel extends PricedItem {
  size: 'small' | 'medium' | 'large';
  ilvl: number;
  passives: number;
}

/** Wire/storage format: history entries are pipe-delimited "price|ts" or "price|ts|type" */
export interface RawPricedItem {
  name: string;
  price: number;
  ts: string;
  type?: PriceType;
  history?: string[];
}

export interface RawPricedClusterJewel extends RawPricedItem {
  size: 'small' | 'medium' | 'large';
  ilvl: number;
  passives: number;
}

export interface Economies {
  league?: string;
  leagueHardcore?: string;
  standard?: string;
  standardHardcore?: string;
}

export interface EconomyState extends Economies {
  ts: string;
}

export interface EconomyStateFile {
  ts: string;
  currency?: Economies;
  uniques?: Economies;
  clusterJewels?: Economies;
}

export enum EcoUpdateBehavior {
  Inform = 'Inform',
  AutoUpdate = 'AutoUpdate',
  AutoUpdateAndSync = 'AutoUpdateAndSync',
}

export interface InflationData {
  previousDate: string;
  latestDate: string;
  previousDivinePrice: number;
  latestDivinePrice: number;
  formatted: string;
  color: string;
  previousUniquesDate: string;
  latestUniquesDate: string;
}
